module.exports = __webpack_public_path__ + "static/media/bed-alt.391f4e11.svg";